import performer1 from "assets/images/main/performers/performer1.webp";
import performer2 from "assets/images/main/performers/performer2.webp";
import performer3 from "assets/images/main/performers/performer3.webp";
import performer4 from "assets/images/main/performers/performer4.webp";
import performer5 from "assets/images/main/performers/performer5.webp";
import performer6 from "assets/images/main/performers/performer6.webp";
import performer7 from "assets/images/main/performers/performer7.webp";
import performer8 from "assets/images/main/performers/performer8.webp";

export const PERFORMERS_DATA = [
  {
    id: 1,
    name: "Маша",
    age: "20 лет",
    occupation: "студентка",
    image: performer1,
    review: (
      <>
        <p>«Учусь на 3 курсе. Выполняю задания вечером или между парами.</p>
        <p>Обычно это поиск товара через маркетплейс или поиск в Яндексе, просмотр карточки, сравнение характеристик, ответы на контрольные вопросы.</p>
        <p>Мне удобно, что задания короткие и понятные».</p>
      </>
    ),
  },
  {
    id: 2,
    name: "Сергей",
    age: "31 год",
    occupation: "работает посменно",
    image: performer2,
    review: (
      <>
        <p>«У меня сменный график, поэтому есть свободные дни.</p>
        <p>Беру задания, где нужно пройти путь пользователя: поиск → переход на страницу → изучение разделов → заполнение отчёта.</p>
        <p>Работаю со своего ноутбука или телефона».</p>
      </>
    ),
  },
  {
    id: 3,
    name: "Ольга",
    age: "38 лет",
    occupation: "в декрете",
    image: performer3,
    review: (
      <>
        <p>«Чаще выполняю задания с телефона.</p>
        <p>Нужно найти объявление, пролистать страницу, провести несколько минут на сайте и ответить на вопросы по впечатлению.</p>
        <p>Все действия делаю самостоятельно, как обычный пользователь».</p>
      </>
    ),
  },
  {
    id: 4,
    name: "Игорь",
    age: "27 лет",
    occupation: "подработка онлайн",
    image: performer4,
    review: (
      <>
        <p>«Учусь на 3 курсе. Выполняю задания вечером или между парами.</p>
        <p>Обычно это поиск товара через маркетплейс или поиск в Яндексе, просмотр карточки, сравнение характеристик, ответы на контрольные вопросы.</p>
        <p>Мне удобно, что задания короткие и понятные».</p>
      </>
    ),
  },
  {
    id: 5,
    name: "Анна",
    age: "24 года",
    occupation: "региональный город",
    image: performer5,
    review: (
      <>
        <p>«Мне интересны задания с обратной связью — посмотреть карточку товара и написать, что понятно, а что вызывает вопросы.</p>
        <p>Это занимает 10–20 минут».</p>
      </>
    ),
  },
  {
    id: 6,
    name: "Алексей",
    age: "23 года",
    occupation: "активный пользователь стримингов",
    image: performer6,
    review: (
      <>
        <p>«Часто слушаю музыку в Яндекс Музыке с телефона.</p>
        <p>Беру задания, где нужно найти трек через поиск, прослушать его полностью, добавить в плейлист или оценить.</p>
        <p>Обычно слушаю во время дороги или тренировок, поэтому задания легко вписываются в привычный режим».</p>
      </>
    ),
  },
  {
    id: 7,
    name: "Наталья",
    age: "42 года",
    occupation: "работает в офисе",
    image: performer7,
    review: (
      <>
        <p>«Иногда беру задания, где нужно перейти по ссылке с внешнего сайта, изучить страницу и заполнить отчёт.</p>
        <p>Важно внимательно прочитать инструкцию и выполнить все шаги».</p>
      </>
    ),
  },
  {
    id: 8,
    name: "Роман",
    age: "35 лет",
    occupation: "живёт в регионе",
    image: performer8,
    review: (
      <>
        <p>«Беру задания по маркетплейсам — найти товар, пролистать карточку, посмотреть фотографии, изучить описание.</p>
        <p>Обычно выполняю с мобильного. На одно задание уходит 10–15 минут».</p>
      </>
    ),
  },
];
